import { UpsellGuard } from 'modules/upselling_kit/components/UpsellGuard'
import { UpsellingKitProductWidget } from 'modules/upselling_kit/types'

import ProductWidgetContent from './_Content'

const ProductWidget = ({
  title,
  description,
  dismissible,
  mediaUrl,
  actions,
  showModuleModal,
  pageSource,
  fallbackComponent,
  ...upsellProps
}: UpsellingKitProductWidget) => {
  return (
    <UpsellGuard {...upsellProps} fallbackComponent={fallbackComponent || null}>
      <ProductWidgetContent
        mediaUrl={mediaUrl}
        dismissible={dismissible}
        title={title}
        description={description}
        actions={actions}
        showModuleModal={showModuleModal}
        pageSource={pageSource}
      />
    </UpsellGuard>
  )
}

export { ProductWidget }
